import { BackStyle } from '@drycut/graphql';
import { Para, Stack } from '@drycut/ui-components';

import ControlledCheckboxInput from './ControlledCheckboxInput';
import ControlledSelectInput from './ControlledSelectInput';

export default function LongHairOptions(): React.ReactElement {
  const BackStyles: Record<BackStyle, string> = {
    [BackStyle.NotDefined]: '—',
    [BackStyle.Straight]: 'Gerade',
    [BackStyle.Rounded]: 'Abgerundet',
  };

  const backStyleOptions = Object.keys(BackStyles).map((key) => ({
    value: key,
    label: BackStyles[key as BackStyle],
  }));

  return (
    <Stack gap={2}>
      <Stack direction="row" className="w-full flex justify-between items-center min-h-10">
        <Para as="label" htmlFor="layers">
          Haare gestuft
        </Para>

        <ControlledCheckboxInput name="layers" />
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="backStyle">
          Haare hinten
        </Para>

        <ControlledSelectInput name="backStyle" options={backStyleOptions} />
      </Stack>
    </Stack>
  );
}
